import { render } from "./ProductosPage.vue?vue&type=template&id=3947c5e7"
import script from "./ProductosPage.vue?vue&type=script&lang=js"
export * from "./ProductosPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__